import { COLORS } from '@/constants';
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const StyledFormControl = styled(FormControl)`
  & .MuiFormControlLabel-root {
    margin-left: 0;
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 0 !important;
  & .MuiFormControlLabel-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;

    @media (max-width: 700px) {
      font-size: 12px;
      font-weight: 300;
    }
  }

  & .MuiFormControlLabel-label.Mui-disabled {
    color: black !important;
  }

  & .MuiCheckbox-root {
    padding: 0 5px 0 0;
  }

  & .MuiCheckbox-root.Mui-checked {
    color: ${COLORS.orange};
    @media (max-width: 959px) {
      color: ${COLORS['primary/500']};
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  & .Mui-checked {
    color: ${COLORS.orange};
    @media (max-width: 959px) {
      color: ${COLORS['primary/500']};
    }
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 26px;
  width: 100%;
`;

export const StyledCountData = styled.span`
  font-size: 10px;
  border: 1px solid ${COLORS['brown/400']};
  padding: 0 4px;
  border-radius: 10px;
  text-align: center;
  width: fit-content;

  @media (max-width: 700px) {
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
  }
`;

export const CustomSelectWrapper = styled(Box)`
  position: relative;
  margin: 8px;
`;

export const CustomSelectInput = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background: white;
  min-height: 40px;
  border-color: ${({ $isOpen }) => ($isOpen ? '#3f51b5' : '#ccc')};
`;

export const CustomSelectDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  margin-top: 4px;
`;

export const CustomSelectChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex-grow: 1;
`;

export const CustomSelectChip = styled.span`
  display: flex;
  align-items: center;
  background: #f0f0f0;
  border-radius: 16px;
  padding: 2px 8px;
  font-size: 14px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #666;
    padding: 0;
  }
`;
